class HeroScroll {
  constructor() {
    this.scrollButton = document.querySelector('.js-hero-scroll');

    if (!this.scrollButton) {
      return;
    }

    this.init();
  }

  init() {
    this.scrollButton.addEventListener('click', () => {
      const block = this.scrollButton.closest('.js-block-hero');

      window.scrollTo({
        top: block.clientHeight,
        left: 0,
        behavior: 'smooth',
      });
    });
  }
}

export default new HeroScroll();



// WEBPACK FOOTER //
// ./src/scripts/modules/hero-scroll.js